import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ParagThree } from './components/HistorySection/HistoryElements';

const resources = {
  pt: {
    translation: {
      nav: { historia: 'História', ambiente: 'Ambiente', culinaria: 'Culinária', fotos: 'Fotos', menu: 'Cardápio'},
      hero: { quote: 'A Varanda do Coração de Bonito', button: 'CONHECER' },
      historia: {
        titulo: 'Nossa História', 
        ParagOne: 'O restaurante Varandas, localizado no coração de Bonito, é um ponto gastronômico tradicional da cidade. Fundado em 1992 e administrado inicialmente pela família do atual proprietário, passou por diferentes donos até retornar à gestão atual em 2016, com o nome de Aquário Restaurante.', 
        ParagTwo: 'Em 2019, o local foi reformado e reaberto como Varandas, com um novo conceito, mantendo seu compromisso com a excelência culinária.', 
        ParagThree: 'Com pratos preparados com ingredientes frescos e de qualidade, o restaurante proporciona um ambiente acolhedor e sofisticado, ideal para almoços ou jantares especiais. A equipe busca sempre criar momentos inesquecíveis para os clientes, fazendo do Varandas um ícone em Bonito.', 
        ParagThree: 'Com pratos preparados com ingredientes frescos e de qualidade, o restaurante proporciona um ambiente acolhedor e sofisticado, ideal para almoços ou jantares especiais. A equipe busca sempre criar momentos inesquecíveis para os clientes, fazendo do Varandas um ícone em Bonito.'},

      ambiente: {texto: '"Sabor, conforto e elegância em cada momento."'},
      culinaria: {
        titulo: 'CULINÁRIA', 
        peixeTitle: 'Peixes', 
        peixeText: 'Desfrute de pratos regionais de peixe feitos com ingredientes frescos e sabores autênticos.', 
        carneTitle: 'CARNES', 
        carneText: 'Saboreie carnes vermelhas regionais com cortes selecionados e temperos tradicionais.', 
        petiscoTitle: 'PESTISCOS', 
        petiscoText: 'Aproveite petiscos locais feitos com ingredientes frescos e toques exclusivos, ideais para compartilhar.'},
        menu: { 
          title: 'Acesse nosso Cardápio', 
          button: 'Conhecer'
        },
        footer: {
          contato: 'Contato', 
          endereco: 'Endereço', 
          rua: 'Rua ',
          distancia: '100 metros da Praça da Liberdade',
          mapa: 'Clique aqui e Veja no Mapa'
        }
    }
  },
  en: {
    translation: {
      nav: { historia: 'History', ambiente: 'Atmosphere', culinaria: 'Cuisine', fotos: 'Photos', menu: 'Menu'},
      hero: { quote: 'The Veranda at the Heart of Bonito', button: 'EXPLORE' },
      historia: {
      titulo: 'Our History',
      ParagOne: 'Varandas restaurant, located in the heart of Bonito, is a traditional gastronomic landmark in the city. Founded in 1992 and initially managed by the current owner\'s family, it passed through different owners until returning to current management in 2016, under the name Aquário Restaurant.',
      ParagTwo: 'In 2019, the establishment was renovated and reopened as Varandas, with a new concept, maintaining its commitment to culinary excellence.',
      ParagThree: 'With dishes prepared using fresh, quality ingredients, the restaurant provides a welcoming and sophisticated atmosphere, ideal for lunches or special dinners. The team always strives to create unforgettable moments for customers, making Varandas an icon in Bonito.'
    },
    ambiente: { texto: '"Flavor, comfort and elegance in every moment."' },
    culinaria: {
    titulo: 'CUISINE',
    peixeTitle: 'Fish',
    peixeText: 'Enjoy regional fish dishes made with fresh ingredients and authentic flavors.',
    carneTitle: 'MEATS',
    carneText: 'Savor regional red meats with selected cuts and traditional seasonings.',
    petiscoTitle: 'APPETIZERS',
    petiscoText: 'Try local appetizers made with fresh ingredients and exclusive touches, perfect for sharing.'
  },
  menu: { title: 'Access our Menu', button: 'Explore'},
  footer: {
  contato: 'Contact', 
  endereco: 'Address', 
  rua: 'Street ',
  distancia: '100 meters from Praça da Liberdade',
  mapa: 'Click here and See on the Map'
}

    }
  },
  es: {
    translation: {
      nav: { historia: 'Historia', ambiente: 'Ambiente', culinaria: 'Gastronomía', fotos: 'Fotos', menu: 'Menú'},
      hero: { quote: 'El Balcón del Corazón de Bonito', button: 'CONOCER' },
      historia: {
      titulo: 'Nuestra Historia',
      ParagOne: 'El restaurante Varandas, ubicado en el corazón de Bonito, es un punto gastronómico tradicional de la ciudad. Fundado en 1992 y administrado inicialmente por la familia del actual propietario, pasó por diferentes dueños hasta retornar a la gestión actual en 2016, con el nombre de Restaurante Aquário.',
      ParagTwo: 'En 2019, el local fue renovado y reabierto como Varandas, con un nuevo concepto, manteniendo su compromiso con la excelencia culinaria.',
      ParagThree: 'Con platos preparados con ingredientes frescos y de calidad, el restaurante proporciona un ambiente acogedor y sofisticado, ideal para almuerzos o cenas especiales. El equipo busca siempre crear momentos inolvidables para los clientes, haciendo de Varandas un ícono en Bonito.'
    },
    ambiente: { texto: '"Sabor, confort y elegancia en cada momento."' },
    culinaria: {
    titulo: 'GASTRONOMÍA',
    peixeTitle: 'Pescados',
    peixeText: 'Disfrute de platos regionales de pescado hechos con ingredientes frescos y sabores auténticos.',
    carneTitle: 'CARNES',
    carneText: 'Saboree carnes rojas regionales con cortes seleccionados y condimentos tradicionales.',
    petiscoTitle: 'APERITIVOS',
    petiscoText: 'Aproveche aperitivos locales hechos con ingredientes frescos y toques exclusivos, ideales para compartir.'
  },
  menu: { title: 'Acceda a nuestro Menú', button: 'Conocer'},
  footer: {
  contato: 'Contacto', 
  endereco: 'Dirección', 
  rua: 'Calle ',
  distancia: '100 metros de la Praça da Liberdade',
  mapa: 'Haga clic aquí para verlo en el mapa.' 
}

    }
  }
};

const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('lng') : null;

i18n.use(initReactI18next).init({
  resources,
  lng: saved || 'pt',
  fallbackLng: 'pt',
  interpolation: { escapeValue: false }
});

i18n.on('languageChanged', (lng) => {
  try { localStorage.setItem('lng', lng); } catch {}
  if (typeof document !== 'undefined') document.documentElement.lang = lng;
});

export default i18n;